
import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const UserInfoForm = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-center">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center space-x-2 cursor-pointer">
                <p className="text-sm text-center text-brand-dark">
                  This tool helps you analyze your market size and provides insights about your business potential.
                </p>
                <HelpCircle className="h-4 w-4 text-brand-secondary" />
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-white p-4 shadow-lg border border-brand-secondary max-w-md">
              <p className="text-sm text-brand-dark">
                Learn more about how Venture Catalysts can support your startup's growth journey.{' '}
                <a 
                  href="https://venturecatalysts.co.uk/for-ventures/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:underline"
                >
                  Visit our website
                </a>
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};
